import { useSelector } from 'react-redux';
import { RootState } from '@nxsys/store';
import { useActionGate } from './useCan';

const REVERSE_PAYROLL_POLICY = 'CompanyDeletePayslips';

export const useCanReversePayroll = (): boolean => {
  const policies = useSelector((state: RootState) => state.appStore.policies);
  return useActionGate(
    'payroll:reversePayslip',
    policies?.includes(REVERSE_PAYROLL_POLICY) ?? false,
  );
};
